var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbubblesSharpNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.5,325.6c-1.2-5-1.4-5.9,3.5-13.1c0.8-1.1,1.5-2.3,2.3-3.3c19.3-28.7,29.7-62.6,29.7-97.2 C480.3,112.5,396.5,32,292.9,32c-90.4,0-165.7,61.5-183.4,143.1c-2.6,12.1-4,24.5-4,36.8c0,99.4,80.6,182.1,184.2,182.1 c16.5,0,38.7-5,50.8-8.3c12.2-3.3,24.2-7.8,27.3-8.9s8-2.4,11.9-1.3l77.4,22.4c2.1,0.6,4.3-0.6,5-2.7c0.2-0.7,0.2-1.4,0-2.2 L444.5,325.6z M232.8,262h-20.5l-39.9-65.5V262h-20.5v-99.5h20.5l40,65.6v-65.6h20.4V262z M317.5,262h-66.7v-99.5h66.6v16.6h-46.1 v23.7h39.4v15.9h-39.4v26.8h46.2V262z M418.8,262h-20.6l-16.2-66.6L365.7,262h-20.6L323,162.5h20.4l13.5,70.7l16.4-70.7h17.4 l16.3,70.8l13.4-70.8h20.4L418.8,262z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.5,415.4c-7.7,1.2-15.5,1.9-23.3,2c-42.4,0-82.5-11.2-115-32.2c-20.8-12.8-38.8-29.5-53.1-49.3 c-26.1-34.6-40.3-78.5-40.3-124.5c0-3.1,0.1-6.1,0.2-9.2c0.1-2.4-1.7-4.4-4.1-4.5c-1.3-0.1-2.5,0.5-3.4,1.4 c-49.3,53.9-55.4,134.5-14.9,195.2c2.5,3.8,3.9,6.7,3.4,8.6l-14.1,72.3c-0.4,2.2,1,4.3,3.2,4.7c0.7,0.1,1.4,0.1,2-0.1l68-24.2 c4.2-1.6,8.8-1.6,12.9,0.2c20.4,8,42.9,12.9,65.4,12.9c43.3,0.1,85.1-16.3,116.6-46c1.7-1.7,1.7-4.4,0.1-6.1 C315.3,415.6,313.9,415.2,312.5,415.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbubblesSharpNew);
export default __webpack_public_path__ + "static/media/chatbubbles-sharp-new.cd0b6d9653f8e046146e888c0dec8902.svg";
export { ForwardRef as ReactComponent };